// @core/api/endpoints/calendar/delete_booking_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete booking link
 * Permanently deletes a booking link. Existing bookings made through this link are preserved.
 */
export async function DeleteBookingLink(
  link_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-links/:link_id`;
  requestPath = requestPath.replace(':link_id', encodeURIComponent(link_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
